import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: { [key: string]: any } = {
  openDemo: false,
  currentVerification: '',
  searchedQuery: {},
  startButtonClicked: false,
  flags: {},
  disclaimerAgreed: {}
};

const misc = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    updateMiscStore(state, action: PayloadAction<object>) {
      return { ...state, ...action.payload };
    },
    clearMiscStore(_state, action: PayloadAction<object>) {
      return { ...initialState, ...action.payload };
    }
  }
});

const { actions, reducer } = misc;
export const { updateMiscStore, clearMiscStore } = actions;
export default reducer;
